/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { IconButton } from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CheckIcon from '@material-ui/icons/Check';
import CrossIcon from '@material-ui/icons/Close';

import { ICustomTheme } from 'interfaces';

const appear = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const cssValidateIcon = () =>
  css({
    animation: `${appear} 1s linear 1`,
  });

const StyledArrowCheckButton = styled(IconButton)<{
  theme: ICustomTheme;
  isClicked: boolean;
}>(({ theme, isClicked }) => ({
  backgroundColor: theme.colors.paletteFromBO.primary,
  color: theme.colors.white,
  transition: 'background-color 0.5s',
  '&:hover': {
    backgroundColor: theme.colors.paletteFromBO.primary,
  },
  '&.Mui-disabled': {
    backgroundColor: theme.colors.grey.light2,
    color: theme.colors.white,
  },
}));

type Props = {
  className?: string;
  isClicked: boolean;
  onClick: () => void;
  disabled?: boolean;
  error?: boolean;
};

function getIcon(error: boolean, isClicked: boolean): any {
  if (isClicked) {
    return [CheckIcon, { css: cssValidateIcon }];
  }

  if (error) {
    return [CrossIcon, {}];
  }

  return [ArrowForwardIcon, {}];
}

const ArrowCheckButton = ({
  className,
  isClicked,
  onClick,
  disabled,
  error,
}: Props): JSX.Element => {
  const [Icon, iconProps] = getIcon(!!error, isClicked);

  return (
    <StyledArrowCheckButton
      aria-label="forward"
      className={className}
      isClicked={isClicked}
      onClick={onClick}
      disabled={disabled}
    >
      <Icon fontSize="large" color="inherit" {...iconProps} />
    </StyledArrowCheckButton>
  );
};

export default ArrowCheckButton;
